var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMessageFilterApplied = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.291 2.7529C12.2974 2.59092 11.1806 2.5 10 2.5C5.85786 2.5 2.5 3.61928 2.5 5V6.03088C2.5 6.44035 2.65074 6.83548 2.92345 7.14091L7.70833 12.5V15.8333C7.70833 16.7538 8.45452 17.5 9.375 17.5H10.625C11.5455 17.5 12.2917 16.7538 12.2917 15.8333V12.5L15.8631 8.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8448 5.84479C17.194 6.49563 16.139 6.49563 15.4881 5.84479C14.8373 5.19396 14.8373 4.13896 15.4881 3.48813C16.139 2.83729 17.194 2.83729 17.8448 3.48813C18.4956 4.13896 18.4956 5.19479 17.8448 5.84479",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMessageFilterApplied);
export default ForwardRef;